(function () {

  console.log("[VariantSlug] script loaded");

  const el = document.getElementById("VariantDeepLinkData");

  if (!el) {
    console.log("[VariantSlug] JSON data not found");
    return;
  }

  const data = JSON.parse(el.textContent || "{}");
  console.log("[VariantSlug] product data:", data);

  const { handle, variants } = data;

  if (!handle || !variants) {
    console.log("[VariantSlug] missing handle or variants");
    return;
  }

  console.log("[VariantSlug] handle:", handle);
  console.log("[VariantSlug] variants count:", variants.length);

  const parts = window.location.pathname.split("/").filter(Boolean);
  console.log("[VariantSlug] URL parts:", parts);

  const productsIdx = parts.indexOf("products");

  if (productsIdx === -1) {
    console.log("[VariantSlug] not a product page");
    return;
  }

  const urlHandle = parts[productsIdx + 1];
  const slug = parts[productsIdx + 2];

  console.log("[VariantSlug] urlHandle:", urlHandle);
  console.log("[VariantSlug] slug:", slug);

  if (!urlHandle || urlHandle !== handle) {
    console.log("[VariantSlug] handle mismatch");
    return;
  }

  if (!slug) {
    console.log("[VariantSlug] no variant slug in URL");
    return;
  }

  const slugify = (s) =>
    String(s || "")
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

  console.log("[VariantSlug] searching for variant...");

  const match = variants.find((v) => {
    const opts = [v.option1, v.option2, v.option3].filter(Boolean);

    const found = opts.some((o) => slugify(o) === slug);

    if (found) {
      console.log("[VariantSlug] match candidate:", v);
    }

    return found;
  });

  if (!match) {
    console.log("[VariantSlug] no variant matched slug:", slug);
    return;
  }

  console.log("[VariantSlug] matched variant ID:", match.id);

  const url = new URL(window.location.href);
  url.searchParams.set("variant", String(match.id));
  url.pathname = `/products/${handle}`;

  console.log("[VariantSlug] redirecting to:", url.toString());

  //window.location.replace(url.toString());

})();